import { boot } from "quasar/wrappers";
import formatDate from "src/filters/formatDate";
import formatPhone from "src/filters/formatPhone";
import formatNumber from "src/filters/formatNumber";
import formatLevelImage from "src/filters/formatLevelImage";
import { Platform } from "quasar";
import { reloadPage } from "src/utils";
import {
  isDeepLinkPath,
  isPublicLinkPath,
  resolveDeepLinkPath,
} from "src/utils/deepLink";

export default boot(({ app, router }) => {
  app.provide("formatDate", formatDate);
  app.provide("formatPhone", formatPhone);
  app.provide("formatNumber", formatNumber);
  app.provide("formatLevelImage", formatLevelImage);

  window.handleOpenURL = (url) => {
    try {
      if (Platform.is.cordova) {
        let splitUrl = url.split("://");
        if (!splitUrl[1]) reloadPage();
        let callbackParams = splitUrl[1]
          .replace(/^store-detail\/+/i, "")
          .split("?");
        let params = new URLSearchParams(callbackParams[1]),
          storeID = callbackParams[0];
        // console.log("storeID", splitUrl, params);
        // Android returns from EAIV through the custom URL scheme with a
        // sessionId; iOS opens EAIV in Safari and picks the result up via the
        // "resume" listener in altria/verified.vue, so it must not route here.
        if (Platform.is.android && storeID && params.get("sessionId")) {
          router.push({
            name: "Home",
          });

          router.push({
            name: "StoreDetail",
            params: { storeid: storeID },
            query: { sessionId: params.get("sessionId") },
          });
        } else {
          let tmpUrl = new URL(url);
          let tmpPath = tmpUrl.pathname;

          if (isPublicLinkPath(tmpPath)) {
            // Public page, no login and no Home push in front of it: the user
            // followed a verification link and should land on its result.
            setTimeout(() => {
              router.push({ path: tmpPath });
            }, 1000);
          } else if (isDeepLinkPath(tmpPath)) {
            const targetPath = resolveDeepLinkPath(tmpPath);
            setTimeout(() => {
              router
                .push({
                  name: "Home",
                })
                .then(() => {
                  router.push({ path: targetPath });
                });
            }, 1000);
          } else {
            // Unknown deep link: send the user Home instead of leaving the app
            // on whatever screen it happened to launch with.
            console.log("DeepLink Unhandled", url);
            setTimeout(() => {
              router.push({ name: "Home" });
            }, 1000);
          }
        }
      }
    } catch (error) {
      console.log("DeepLink Error", error);
    }
  };
});
